// @flow @jsx h

import { h } from 'preact'
import styles from './index.css'
import { bem } from '@nrk/dh-utils'

type Props = {
  children: any,
  centered?: boolean,
  ariaHidden: boolean
}

const Foreground = ({ children, centered, ariaHidden }: Props) => {
  return (
    <div class={bem(styles.foreground, { centered })} aria-hidden={ariaHidden}>
      <div class={styles.foreground__inner}>{children}</div>
    </div>
  )
}

export { Foreground }



// WEBPACK FOOTER //
// ./src/v1/components/Foreground/index.js